import React from 'react';
import { Card } from '@/lib/components/ui/card';

interface MonthDaysContentProps {
  selectedMonthDays: Set<number>;
  onMonthDayToggle: (day: number) => void;
  onMonthDayClick?: (day: number) => void;
}

const monthDays = Array.from({ length: 31 }, (_, i) => i + 1);

export const MonthDaysContent: React.FC<MonthDaysContentProps> = ({ selectedMonthDays, onMonthDayToggle }) => {
  return (
    <div className="bg-gradient-to-br from-gray-50/30 via-white to-blue-50/20 p-8">
      <div className="animate-fade-in mb-8">
        <h2 className="bg-gradient-to-r from-gray-900 to-blue-900 bg-clip-text text-3xl font-bold text-transparent">
          Month Days
        </h2>
        <p className="animate-fade-in animation-delay-100 mt-2 text-gray-600">
          Select which days of the month access is allowed
        </p>
      </div>

      <div className="grid grid-cols-7 gap-4">
        {monthDays.map((day, index) => {
          const isSelected = selectedMonthDays.has(day);

          return (
            <Card
              key={day}
              className={`group animate-fade-in relative cursor-pointer overflow-hidden border-2 bg-white/60 p-4 backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg hover:shadow-black/5 ${
                isSelected
                  ? 'scale-[1.02] transform border-blue-500/50 bg-gradient-to-br from-blue-50 to-blue-100/50 shadow-lg shadow-blue-100'
                  : 'border-gray-200/50 hover:border-blue-300 hover:bg-blue-50/30'
              }`}
              style={{ animationDelay: `${index * 30 + 200}ms` }}
              onClick={() => onMonthDayToggle(day)}
            >
              {/* Selection Indicator */}
              {isSelected && (
                <div className="absolute top-2 right-2">
                  <div className="flex h-4 w-4 items-center justify-center rounded-full bg-blue-100 shadow-sm">
                    <div className="h-1.5 w-1.5 rounded-full bg-blue-600"></div>
                  </div>
                </div>
              )}

              <div className="flex items-center justify-center">
                <span
                  className={`text-lg font-semibold transition-colors ${
                    isSelected ? 'text-blue-700' : 'text-gray-700 group-hover:text-gray-900'
                  }`}
                >
                  {day}
                </span>
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
};
